<template>
    <CodiceFeanorView tool-module="ffufWorkbench" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
